import axios from 'axios';

const createActivity = async ({ data, token } = {}) => {

  console.log(data)

  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/activities`,
      data,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    // Sentry TODO
    return { error };
  }
};

export default createActivity;
